<!---->
<template>
  <el-form
    ref="form"
    v-bind="$attrs"
    :label-position="labelPosition"
    class="rt-form-wrapper"
  >
    <slot />
  </el-form>
</template>

<script>
export default {
  name: 'RtForm',
  data() {
    return {
      labelPosition: 'top'
    };
  },
  methods: {
    validate(cb) {
      this.$refs.form.validate(validate => {
        cb(validate);
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtForm.vue?3081ef4a